module.exports = __webpack_public_path__ + "static/media/21.4e8b4731.mp3";